import React from "react";
import LobConstants from "../../constants/LobConstants";
import icons from "./Icons";

const SidenavData = {
  menus: [
    // 1. Home
    {
      text: "Home",
      icon: <icons.HomeRounded />, // keep or replace with actual icon
      link: `/${LobConstants.LOB}/`,
    },
    // 2. Job
    {
      text: "Job",
      icon: <icons.Job />,
      subMenus: [
        {
          text: "SFTO",
          link: `/${LobConstants.LOB}/job/sfto/listjob`,
        },
        {
          text: "GPWIS",
          link: `/${LobConstants.LOB}/job/gpwis/listjob`,
        },
      ],
    },

    // 3. Invoice
    {
      text: "Invoice",
      icon: <icons.Invoice />,
      subMenus: [
        {
          text: "Submission Details",
          link: `/${LobConstants.LOB}/invoice/submissiondetails`,
        },
        // 3.c Rebate Invoice (existing top-level moved under Invoice)
        {
          text: "Submission to Customer",
          link: `/${LobConstants.LOB}/invoice/submissiontocustomer`,
        },
        // 3.b Consolidated Invoice (existing top-level moved under Invoice)
        {
          text: "Consolidated Invoice",
          link: `/${LobConstants.LOB}/consolidatedinvoice`,
        },
        // 3.c Rebate Invoice (existing top-level moved under Invoice)
        {
          text: "Rebate Invoice",
          link: `/${LobConstants.LOB}/reports/invoicegenreport`,
        },
        {
          text: "MGT Invoice",
          link: `/${LobConstants.LOB}/mgtinvoice`,
        },
        {
          text: "Invoice Management (Eproc)",
          link: `/${LobConstants.LOB}/invoice/eproc`,
        },
        {
          text: "Eproc Report",
          link: `/${LobConstants.LOB}/invoice/eprocreport`,
        },
        {
          text: "Eproc Data Upload",
          link: `/${LobConstants.LOB}/invoice/eprocdataupload`,
        },
      ],
    },

    // 4. Maintenance
    {
      text: "Maintenance",
      icon: <icons.Maintainance />,
      subMenus: [
        {
          text: "Rake Current Composition",
          link: `/${LobConstants.LOB}/maintenance/currentcomposition/list`,
        },
        {
          text: "Schedule Maintenance",
          link: `/${LobConstants.LOB}/maintenance/schedulemaintenance/list`,
        },
        {
          text: "Spare Maintenance",
          link: `/${LobConstants.LOB}/maintenance/spareschedulemaintenance/list`,
        },
      ],
    },

    // 5. Reports
    // {
    //   text: "Reports",
    //   icon: <icons.ReportsIcon />,
    //   subMenus: [
    //     {
    //       text: "SFTO - Rake Detention Report",
    //       link: "/railways/reports/rakedetentionreport",
    //     },
    //     {
    //       text: "SFTO - Tonnage Report",
    //       link: "/railways/reports/tonnagereport",
    //     },
    //     {
    //       text: "SFTO - IDLE Weight Report",
    //       link: "/railways/reports/idelWeightReport",
    //     },
    //     {
    //       text: "SFTO - Trip Wise Profitability report",
    //       link: "/railways/reports/tripwiseProfitabilityReport",
    //     },
    //     {
    //       text: "SFTO - Job Details Report",
    //       link: "/railways/reports/sftoJobDetailsReport",
    //     },
    //     {
    //       text: "GPWIS - Job Details Report",
    //       link: "/railways/reports/gpwisJobDetailsReport",
    //     },
    //     {
    //       text: "GPWIS - Rebate Summary report",
    //       link: "/railways/reports/rebatesummaryreport",
    //     },
    //     {
    //       text: "GPWIS - Rebate Transaction Report",
    //       link: `/${LobConstants.LOB}/reports/rebatetransactionreport`,
    //     },
    //     {
    //       text: "Invoice Report",
    //       link: "/railways/reports/invoicereport",
    //     },
    //     {
    //       text: "TAT Report",
    //       link: `/${LobConstants.LOB}/reports/tatreport`,
    //     },
    //   ],
    // },

    // 6. Master
    {
      text: "Masters",
      icon: <icons.Masters />,
      subMenus: [
        {
          text: "Contract Master",
          link: `/${LobConstants.LOB}/masters/contractMaster/list`,
        },
        {
          text: "Vendor Contract Master",
          link: `/${LobConstants.LOB}/masters/vendorMaster/list`,
        },
        {
          text: "Commodity Master",
          link: `/${LobConstants.LOB}/masters/commoditymaster/list`,
        },
        {
          text: "Ship To Party Master",
          link: `/${LobConstants.LOB}/masters/shiptopartymaster/list`,
        },
        {
          text: "Rake Master",
          link: `/${LobConstants.LOB}/masters/rakemaster/list`,
        },
        {
          text: "Route Master",
          link: `/${LobConstants.LOB}/masters/routemaster/list`,
        },
        {
          text: "Wagon Master",
          link: `/${LobConstants.LOB}/masters/wagonmaster/list`,
        },
        {
          text: "SAP Transation Details",
          link: `/${LobConstants.LOB}/saptransactiondefaults`,
        },
        {
          text: "Contract Advance",
          link: `/${LobConstants.LOB}/saptransaction/contractadvance`,
        },
        {
          text: "Customer Threshold Master",
          link: `/${LobConstants.LOB}/masters/thresholdmaster/list`,
        },
        {
          text: "Material Class Master",
          link: `/${LobConstants.LOB}/masters/materialclassmaster/list`,
        },
        {
          text: "Frieght Master",
          link: `/${LobConstants.LOB}/masters/frieghtmaster/list`,
        },
        {
          text: "Rake Rebate Master",
          link: `/${LobConstants.LOB}/masters/rakerebatemaster/list`,
        },
        {
          text: "OD pair Master",
          link: `/${LobConstants.LOB}/masters/odpairmaster/list`,
        },
        {
          text: "TAT Reconciliation Master",
          link: `/${LobConstants.LOB}/masters/tatreconciliationmaster/list`,
        },
        {
          text: "Station Master",
          link: `/${LobConstants.LOB}/masters/stationmaster/list`,
        },
        {
          text: "Examination Type Master",
          link: `/${LobConstants.LOB}/masters/examinationtypemaster/list`,
        },
        {
          text: "Depot Master",
          link: `/${LobConstants.LOB}/masters/depomaster/list`,
        },
        {
          text: "Wagon Component Master",
          link: `/${LobConstants.LOB}/masters/wagoncomponentmaster/list`,
        },
        {
          text: "ROH/POH Schedule Master",
          link: `/${LobConstants.LOB}/masters/rohpohschedulemaster/list`,
        },
        // 6.b Monthly Target (moved from prior top level)
        {
          text: "Monthly targets",
          link: `/${LobConstants.LOB}/dailypositionreport/list`,
        },
      ],
    },

    // 7. SFTO Freight Reconciliation
    {
      text: "SFTO Freight Reconciliation",
      icon: <icons.SFTOReconciliation />,
      subMenus: [
        {
          text: "SFTO Freight Reconciliation Main",
          link: `/${LobConstants.LOB}/sfto/reconciliation/main`,
        },
        {
          text: "SFTO Freight Reconcillation Completed",
          link: `/${LobConstants.LOB}/sfto/reconciliation/complete`,
        },
        {
          text: "Account to TMILL",
          link: `/${LobConstants.LOB}/sfto/reconciliation/account-tmill-workflow`,
        },
        {
          text: "Account to Customer",
          link: `/${LobConstants.LOB}/sfto/reconciliation/account-customer-workflow`,
        },
        {
          text: "Account to Insurance",
          link: `/${LobConstants.LOB}/sfto/reconciliation/account-insurance-workflow`,
        },
        {
          text: "Account to Railways",
          link: `/${LobConstants.LOB}/sfto/reconciliation/account-railways-workflow`,
        },
      ],
    },

    // 8. Others
    {
      text: "Others",
      icon: <icons.RakeInduction />,
      subMenus: [
        // 8.a DSR (uses the prior DSR section’s links)
        {
          text: "Dashboard",
          link: `/${LobConstants.LOB}/dashboard`,
        },
        {
          text: "DSR - View Live Jobs",
          link: `/${LobConstants.LOB}/dsr/list`,
        },

        // 7.b Wagon Damage
        {
          text: "DSR - Track Rake",
          link: `/${LobConstants.LOB}/trackrake`,
        },

        // 8.b Wagon Damage
        {
          text: "Wagon Damage",
          link: `/${LobConstants.LOB}/wagondamage/list`,
        },

        // 8.c Rake Maintenance
        {
          text: "Rake Maintenance",
          link: `/${LobConstants.LOB}/rakemaintenance/list`,
        },

        // 8.d Rake Induction
        {
          text: "Rake Induction",
          link: `/${LobConstants.LOB}/rakeinduction/list`,
        },
        {
          text: "SFTO - Rake Detention Report",
          link: "/railways/reports/rakedetentionreport",
        },
        {
          text: "SFTO - Tonnage Report",
          link: "/railways/reports/tonnagereport",
        },
        {
          text: "SFTO - IDLE Weight Report",
          link: "/railways/reports/idelWeightReport",
        },
        {
          text: "SFTO - Trip Wise Profitability report",
          link: "/railways/reports/tripwiseProfitabilityReport",
        },
        {
          text: "SFTO - Job Details Report",
          link: "/railways/reports/sftoJobDetailsReport",
        },
        {
          text: "GPWIS - Job Details Report",
          link: "/railways/reports/gpwisJobDetailsReport",
        },
        {
          text: "GPWIS - Rebate Summary report",
          link: "/railways/reports/rebatesummaryreport",
        },
        {
          text: "GPWIS - Rebate Transaction Report",
          link: `/${LobConstants.LOB}/reports/rebatetransactionreport`,
        },
        {
          text: "Invoice Report",
          link: "/railways/reports/invoicereport",
        },
        {
          text: "TAT Report",
          link: `/${LobConstants.LOB}/reports/tatreport`,
        },
      ],
    },
  ],
};

export default SidenavData;
